define(['underscore'], (_)=> {
    const METADATA_CLASS = 'edge.aspects.validation.dto.RuleAugmentationRuleDTO';


    /** Returns a list of augments derived from the metadata. */
    function getAugmentsFromMeta(expressionLanguage, metadata, targetType, targetPath, currentNode, parentNode) {
        const augments = metadata.elementMetadata.get(METADATA_CLASS);
        const applicableAugments = augments.filter((augment)=> {
            return augment.targets.indexOf(targetPath) >= 0;
        });
        const res = [];

        applicableAugments.forEach((augment)=> {
            const cond = augment.when ? expressionLanguage.compile(augment.when) : _.constant(true);
            const targetMetas = augment.augments.filter((override)=> {
                return override.type === targetType;
            }).map((override)=> {
                return override.value;
            });

            targetMetas.forEach((meta)=> {
                res.push({
                    'shouldApply': ()=> {
                        /* Explicit cast to a true due to three-state value: true, false and NONSENSE. */
                        return cond(currentNode, parentNode, currentNode.aspects.context) === true;
                    },
                    'data': meta,
                    'node': currentNode,
                    parentNode
                });
            });
        });

        return res;
    }

    /** Collects rules from all the nodes. */
    function collectRules(expressionLanguage, node, nodeMetadata, ancestorChain, targetType) {
        const res = [];
        const localMeta = nodeMetadata.elementMetadata.get(targetType);
        localMeta.forEach((targetMeta)=> {
            res.push({
                'shouldApply': _.constant(true),
                'data': targetMeta,
                node,
                'parentNode': ancestorChain.parent
            });
        });

        for (let ancestorIdx = ancestorChain.owners.length - 1; ancestorIdx >= 0; ancestorIdx--) {
            const owner = ancestorChain.owners[ancestorIdx];
            const parent = ancestorIdx === 0 ? undefined : ancestorChain.owners[ancestorIdx - 1].container;
            const inheritedAugments = getAugmentsFromMeta(expressionLanguage, owner.metadata, targetType, owner.pathToItem.asString, owner.container, parent);
            res.push.apply(res, inheritedAugments);
        }

        return res;
    }

    /** Utilities for the augmentable properties. */
    return {
        collectRules
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/viewmodel/aspects/_Augment.js